module.exports = __webpack_public_path__ + "assets/geopolitical.0cf72ecb.svg";